import { accountServiceModule } from '../../services/account-service/account-service';
import { checkEmailServiceModule } from '../../services/check-email-service/check-email-service';
import { uniqueEmailValidatorComponentModule } from '../forms/unique-email-validator/unique-email-validator';
import { serverValidationErrorsComponentModule } from '../forms/server-validation-errors/server-validation-errors';
import { trackComponentModule } from '../track/track';
import signupOrLoginTemplate from './signup-or-login.tpl.html';
import './signup-or-login.less';
import { getCookie } from '../../utils/cookie-utils';

export const signupOrLoginComponentModule = angular
  .module('Q.components.signup-or-login', [
    accountServiceModule,
    checkEmailServiceModule,
    uniqueEmailValidatorComponentModule,
    serverValidationErrorsComponentModule,
    trackComponentModule,
  ])

  .directive('signupOrLogin', function ($timeout) {
    return {
      restrict: 'E',
      scope: {
        nextButtonLabel: '@',
        user: '=?',
        loginMode: '=?',
        forgotPasswordMode: '=?',
        activateMode: '<',
        activateToken: '<',
        passwordNotRequired: '<',
        disableSignup: '<',
        signupLink: '@',
        disableLogin: '<',
        showMsa: '<',
        showTerms: '<',
        showPrivacy: '<',
        showNewsletter: '<',
        enableRememberMe: '<',
        allowSaml: '<',
        onSignup: '&',
        onLogin: '&',
        onActivate: '&',
        onCancel: '&',
        hideLoadingPanel: '<',
      },
      template: signupOrLoginTemplate,
      controller: 'SignupOrLoginCtrl as signupOrLogin',
      bindToController: true,
      require: 'signupOrLogin',
      link(scope, elem, attr, signupOrLoginCtrl) {
        if (attr.onCancel) {
          signupOrLoginCtrl.hasCancel = true;
        }
        signupOrLoginCtrl.focusInput = () => {
          $timeout(() => {
            let inputs = elem[0].querySelectorAll('a, button, input');
            let i = 0;
            while (i < inputs.length) {
              if (inputs[i].focus && angular.element(inputs[i]).isVisible()) {
                inputs[i].focus();
                break;
              }
              i++;
            }
          }, 500);
        };
        signupOrLoginCtrl.focusInput();
      },
    };
  })

  .controller(
    'SignupOrLoginCtrl',
    function SignupOrLoginCtrl(
      $scope,
      $element,
      accountService,
      checkEmailService,
      serverValidationService,
      $q,
      $injector,
    ) {
      const ctrl = this;
      let alreadyHasName = false;
      ctrl.$onInit = () => {
        ctrl.logoutReason =
          accountService.LOGOUT_REASONS[accountService.logoutReason];

        if (!ctrl.user) {
          ctrl.user = {};
        } else {
          alreadyHasName = !!(ctrl.user.firstName && ctrl.user.lastName);
        }

        if (ctrl.allowSaml) {
          ctrl.samlUrl = getCookie('saml_login');
        }

        if (ctrl.disableSignup) {
          ctrl.loginMode = true;
        }

        if (
          ctrl.user &&
          ctrl.user.hasPassword &&
          ctrl.activateToken &&
          ctrl.activateMode
        ) {
          ctrl.autoActivated = true;
          const promise = _activate();
          promise.catch(() => {
            ctrl.autoActivated = false;
          });
          ctrl.onActivate({ promise });
        }

        ctrl.modelName = accountService.modelName;

        ctrl.focusInput = angular.noop;
        ctrl.trackerName = () => (ctrl.loginMode ? 'Login' : 'Signup');

        ctrl.forgotPasswordSent = false;
        ctrl.loginFailed = false;
        ctrl.accountLocked = false;
        ctrl.disabled = false;

        ctrl.switchLoginMode = () => {
          if (ctrl.loginMode && ctrl.signupLink) return;
          ctrl.loginMode = !ctrl.loginMode;
          _clearFormErrors();
        };
        ctrl.switchForgotPasswordMode = () => {
          ctrl.forgotPasswordMode = !ctrl.forgotPasswordMode;
          _clearFormErrors();
        };

        // Hack for LastPass and other poor password managers to try and validate changed inputs before submitting.
        ctrl.updateModels = () => {
          let inputs = angular.element($element.find('input'));
          inputs.triggerHandler('input');
          return true;
        };

        ctrl.login = () => {
          if (ctrl.forgotPasswordMode) {
            _forgotPassword();
          } else if (ctrl.activateMode) {
            ctrl.onActivate({ promise: _activate() });
          } else if (ctrl.loginMode) {
            ctrl.onLogin({ promise: _emailLogin() });
          } else {
            ctrl.onSignup({ promise: _emailSignup() });
          }
        };

        /**
         * Returns true if any login has been configured
         * @returns {*|boolean}
         */
        ctrl.hasAnyLogin = () => {
          return (
            (ctrl.user.email &&
              ctrl.user.password &&
              ctrl.user.firstName &&
              ctrl.user.lastName) ||
            (ctrl.user.id && ctrl.user.hasPassword)
          );
        };

        /**
         * Returns true if first/last name are required
         * @returns {boolean}
         */
        ctrl.signupNameRequired = () => {
          return !ctrl.loginMode && !ctrl.forgotPasswordMode && !alreadyHasName;
        };

        /**
         * Returns true if password field is required
         * @returns {boolean}
         */
        ctrl.passwordRequired = () => {
          return !ctrl.forgotPasswordMode && !ctrl.passwordNotRequired;
        };

        ctrl.resetErrors = () => {
          ctrl.loginFailed = false;
          ctrl.accountLocked = false;
        };

        if ($injector.has('productMaintenanceService')) {
          ctrl.maintenanceWarning = $injector
            .get('productMaintenanceService')
            .warning();
        }

        //// private functions

        function _clearFormErrors() {
          ctrl.forgotPasswordSent = false;
          ctrl.loginFailed = false;
          ctrl.accountLocked = false;
          ctrl.agreeToMsa = false;
          serverValidationService.clearErrors();
          $scope.signupOrLoginForm.email.$validate();
          $scope.signupOrLoginForm.$setPristine();
          $scope.signupOrLoginForm.$setUntouched();
          ctrl.focusInput();
        }

        function _forgotPassword() {
          ctrl.disabled = true;
          return accountService
            .forgotPassword(ctrl.user.email)
            .then(() => {
              ctrl.forgotPasswordSent = true;
            })
            .catch((resp) => {
              if (resp && resp.status === 404) {
                ctrl.loginFailed = true;
              }
            })
            .then(
              serverValidationService.clearErrors,
              serverValidationService.getErrorHandler({ ignoredCodes: 404 }),
            )
            .finally(() => (ctrl.disabled = false));
        }

        /**
         * Logs in via email and password
         * @returns {*}
         * @private
         */
        function _emailLogin() {
          ctrl.disabled = true;
          return accountService
            .login(ctrl.user.email, ctrl.user.password, {
              rememberMe: !!ctrl.rememberMe,
              showLoadingPanel: !ctrl.hideLoadingPanel,
            })
            .then(
              (account) => account.user,
              (response) => {
                if (response.data && response.data.maintenanceMode) {
                  return $q.reject(response);
                } else {
                  ctrl[
                    response.status === 423 ? 'accountLocked' : 'loginFailed'
                  ] = true;
                  return $q.reject();
                }
              },
            )
            .then(
              serverValidationService.clearErrors,
              serverValidationService.getErrorHandler(),
            )
            .finally(() => (ctrl.disabled = false));
        }

        /**
         * Signs up via email and password
         * @returns {*}
         * @private
         */
        function _emailSignup() {
          ctrl.disabled = true;
          return accountService
            .createAccount(ctrl.user, {
              rememberMe: !!ctrl.rememberMe,
              showLoadingPanel: !ctrl.hideLoadingPanel,
            })
            .then((account) => account.user)
            .then(
              serverValidationService.clearErrors,
              serverValidationService.getErrorHandler(),
            )
            .finally(() => (ctrl.disabled = false));
        }

        /**
         * Activates a user via email
         * @returns {*}
         * @private
         */
        function _activate() {
          ctrl.disabled = true;
          return accountService
            .activate(
              {
                token: ctrl.activateToken,
                firstName: ctrl.user.firstName,
                lastName: ctrl.user.lastName,
                password: ctrl.user.password,
                subscribeToNewsletter: ctrl.user.subscribeToNewsletter,
              },
              {
                rememberMe: !!ctrl.rememberMe,
                showLoadingPanel: !ctrl.hideLoadingPanel,
              },
            )
            .then((account) => account.user)
            .then(
              serverValidationService.clearErrors,
              serverValidationService.getErrorHandler({
                ignoredCodes: [403, 404, 423],
              }),
            )
            .catch((resp) => {
              if (resp) {
                if (resp.status === 403) {
                  serverValidationService.setErrors(
                    'This account has either already been activated or the activation token is no longer valid.',
                  );
                } else if (resp.status === 404) {
                  serverValidationService.setErrors(
                    'The activation token is no longer valid. Did you already activate your account?',
                  );
                } else if (resp.status === 423) {
                  serverValidationService.setErrors(
                    'This account is locked, so it cannot be activated at this time.',
                  );
                }
              }
              return $q.reject(resp);
            })
            .finally(() => (ctrl.disabled = false));
        }
      };
    },
  );
